import React, { useEffect, useRef, useState } from "react";
import { IFieldPopup } from '../interFaces/interfaces';
import "../css/others/Popup.css";
const FieldPopup: React.FC<IFieldPopup> = ({ isOpen, fieldName, fieldValue, onSave, onClose,}) => {
    const [value, setValue] = useState(fieldValue);
    const popupRef = useRef<HTMLDivElement>(null);
    useEffect(() => { setValue(fieldValue);}, [fieldValue]);
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
                onClose();
            }
        };
        if (isOpen) {document.addEventListener("mousedown", handleClickOutside);}
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen, onClose]);
    if (!isOpen) return null;
    return (
        <div className="popup-overlay">
            <div className="field-popup" ref={popupRef}>
                <h3>{fieldName}</h3>
                <textarea value={value} onChange={(e) => setValue(e.target.value)} placeholder={`Enter ${fieldName}`} rows={5}/>
                <div className="popup-buttons">
                    <button className="cancelbutton" onClick={onClose}>Cancel</button>
                    <button className="savebutton" onClick={() => onSave(value)}>Ok</button>
                </div>
            </div>
        </div>
    );
};
export default FieldPopup;